import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { logBreadcrumb, recordHandledError } from '@/utils/logger.util';

/**
 * Central recording for server-state failures. The axios interceptor already reports 5xx, so
 * this layer only leaves a breadcrumb naming *which* query or mutation failed — that context is
 * what turns "a request 500'd" into "the rentals list failed to load".
 *
 * The per-page `vm.isError` UI stays the user-facing surface; this only records.
 */
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      logBreadcrumb(`query failed: ${JSON.stringify(query.queryKey)}`, {
        message: error.message,
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // Mutations are user-initiated writes — a failure here is worth an event of its own,
      // not just a breadcrumb, because it usually means an admin action silently didn't happen.
      recordHandledError(error, {
        mutationKey: JSON.stringify(mutation.options.mutationKey ?? 'unkeyed'),
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
